import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxThreeMonthsAhead(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const inputDate = new Date(control.value);
    const maxDate = new Date();

    maxDate.setMonth(maxDate.getMonth() + 3);

    inputDate.setHours(0, 0, 0, 0);
    maxDate.setHours(0, 0, 0, 0);

    return inputDate > maxDate
      ? { maxThreeMonthsAhead: true }
      : null;
  };
}
